<template>
  <div>
    <v-card :loading="loading">
      <v-toolbar dense flat color="blue-grey lighten-5" height="30">
        <v-toolbar-title class="subtitle-1">Expediente</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn v-if="!soloLectura && !expediente" x-small icon fab @click="add = true">
          <v-icon>fa-plus</v-icon>
        </v-btn>
        <span v-if="caja">
          No. de caja: {{caja.numero}}
        </span>
        <menu-item :items="menuItems" :id="expediente._id" @menuAction="menuAction" v-if="!soloLectura && expediente && !caja"/>
      </v-toolbar>
      <v-card-text v-if="!expediente" class="d-flex pa-2">
        Sin datos registrados, presione el botón "+" para agregar un expediente.
        <v-spacer></v-spacer>
        <v-icon>mdi-arrow-up</v-icon>
      </v-card-text>
      <v-card-text v-else>
        <v-row no-gutters align="center">
          <v-col cols="12" md="6" class="mb-4 mb-md-0">
            <v-row no-gutters justify="center" justify-md="start">
              <v-icon color="blue-grey darken-1" class="mr-4" size="30" @click="mostrar = true">
                mdi-folder-open
              </v-icon>
              <div class="d-flex flex-column" >
                <span class="grey--text  subtitle-2 text--darken-3">{{ expediente &&
      expediente.unidadAdministrativa.nombre }}</span>
                <span class="subtitle-2">{{ expediente && expediente.serie.nombre }}</span>
                <a class="caption" @click="mostrar = true">{{ expediente && expediente.clave }}</a>
              </div>
              
            </v-row>
          </v-col>
          <v-col cols="12" md="6">
            <v-row no-gutters justify="center" justify-md="end">
              <v-btn v-if="!soloLectura" @click="modificar = true" :loading="loadingButtons" small color="blue-grey darken-1" dark class="mx-1">
                <v-icon left small>fa-edit</v-icon>Editar
              </v-btn>
              <v-btn v-if="!soloLectura" @click="etiqueta = true" :loading="loadingButtons" small color="blue-grey darken-1" dark class="mx-1">
                <v-icon left small>mdi-printer</v-icon>Etiquetas Folders
              </v-btn>
              <v-btn v-if="!soloLectura" @click="getCaratula()" :loading="loadingButtons" small color="blue-grey darken-1" dark class="mx-1">
                <v-icon left small>mdi-printer</v-icon>Cáratula
              </v-btn>
             
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!--  Nuevo Expediente -->
    <agregar-expediente v-if="add" :mostrar="add" @cancelar="add = false" @guardar="guardarExpediente" />
    <!-- Modificar Expediente -->
    <agregar-expediente v-if="modificar" :mostrar="modificar" @cancelar="modificar = false" @guardar="guardarExpediente"
      :expediente="expediente" />
    <!-- ver expediente -->
    <agregar-expediente v-if="mostrar" :mostrar="mostrar" @cancelar="mostrar = false" :expediente="expediente"
      :ver="true" />
    <!-- Generar Etiquetas -->
    <generar-etiquetas v-if="etiqueta" :etiqueta="etiqueta" @close="etiqueta = false" />

    <agregar-caja v-if="agregarCaja" :mostrar="agregarCaja" :tipoCaja="tipoCaja" @cancelar="agregarCaja=false" :expediente="expediente._id" @cajaAgregada="cajaAgregada"/>

  </div>
</template>
<script>

import { getExpediente, getCaratulaService } from "./expediente.service"
import agregarExpediente from "./agregarExpediente.vue"
import generarEtiquetas from './generarEtiquetas.vue';
import agregarCaja from '../archivo/agregarCaja.vue'
import MenuItem from '../menus/MenuItem.vue'
import { getCajaExpediente } from '../../components/archivo/archivo.service'
export default {
  name: "expediente",
  props: ["loading", "soloLectura", "idOficio"],
  components: {
    agregarExpediente,
    generarEtiquetas,
    agregarCaja,
    MenuItem

  },
  data: () => ({
    expediente: null,
    add: false,
    modificar: false,
    etiqueta: false,
    mostrar: false,
    loadingButtons: false,
    menuItems: [
        {text:'Agregar a nueva caja', action: 'nuevaCaja'},
        {text:'Agregar a caja existente', action: 'existente'},
      ],
    agregarCaja:false,
    caja:null

  }),
  async created() {
    try {
      const serverResponse = await getExpediente(this.idOficio);
      if (!serverResponse.ok) throw new Error(serverResponse.mensaje)
      this.expediente = serverResponse.expediente;
      if(this.expediente){
        const server = await getCajaExpediente(this.expediente._id)
        if(!server) throw new Error(server.mensaje)
        this.caja = server.caja
      }
    } catch (error) {
      this.$notificarError(error);
    }
  },
  methods: {
     menuAction(action, id){
            switch(action){
                case 'nuevaCaja':
                    this.agregarCaja=true
                    this.tipoCaja='nueva'
                    break;
                case 'existente':
                    this.agregarCaja=true;
                    this.tipoCaja='existente'
                    break;
                default:
                    break;

              
            }
        },
    guardarExpediente(expediente) {
      this.expediente = expediente;
    },
    async getCaratula() {
      this.loadingButtons = true;
      try {
        const caratula = await getCaratulaService(this.$route.params.id, this.$route.params.tipo);
        if (caratula.type != 'application/pdf') {
          const ServerResponse = JSON.parse(await caratula.text())
          this.$notificarError(ServerResponse.mensaje);
        }
        else {
          const url = window.URL.createObjectURL(caratula);
          window.open(url);
        }
      } catch (error) {
        console.error(error);
      }
      this.loadingButtons = false;
    },
    cajaAgregada(data){
      this.caja=data
    }
  }
}
</script>
